import 'App.scss';
import 'bootstrap/dist/js/bootstrap.bundle'
import StateContextProvider from 'context/StateContext';
import { BrowserRouter } from 'react-router-dom';
import Routes from 'routes/Routes'
import 'aos/dist/aos.css'
import { useEffect, useState } from 'react';
import LoadingAnimation from 'components/loading/LoadingAnimation';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // this useEffect used for loading
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);

  }, []);

  return (
    <>
      <BrowserRouter>
        <StateContextProvider>
          <HelmetProvider>
            {/* Here i add and condition in which 2 components added, "LoadingAnimation" and "Routes". 
          If website is loading then loading animation will run and when loading is closed then Route will execute */}
            {isLoading ? <LoadingAnimation /> : <Routes />}
          </HelmetProvider>
        </StateContextProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
